// extracted by mini-css-extract-plugin
export default {"item":"MMSF-Item_item__ulW4s","Standard":"MMSF-Item_Standard__J6gAC","Mega":"MMSF-Item_Mega__Aqncw","Giga":"MMSF-Item_Giga__2UPsh"};